import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import {
  Menu as MenuIcon,
  ExitToApp,
  Person,
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAuth } from '../../contexts/AuthContext';

const Header = ({ onMenuToggle, showMenuButton = false }) => {
  const { currentUser, logout } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleProfileMenuClose();
    logout();
  };

  // Obtener iniciales del nombre
  const getInitials = (name) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: { md: `calc(100% - 240px)` },
        ml: { md: `240px` },
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #e5e7eb',
        boxShadow: 'none',
      }}
    >
      <Toolbar
        sx={{
          minHeight: 64,
          paddingX: 3,
        }}
      >
        {/* Logo/Marca en móvil con función de menú */}
        <Box
          onClick={isMobile ? onMenuToggle : undefined}
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: isMobile ? 'pointer' : 'default',
            marginRight: 2,
          }}
        >
          {isMobile && (
            <IconButton
              edge="start"
              sx={{
                padding: 0.5,
                marginRight: 1,
                color: '#374151',
              }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography
            variant="h6"
            component="div"
            sx={{
              color: '#111827',
              fontWeight: 600,
              fontSize: isMobile ? '1rem' : '1.125rem',
            }}
          >
            {`Hola ${currentUser?.name || currentUser?.nombre || 'Usuario'} bienvenido a eWeAlert`}
          </Typography>
        </Box>

        {/* Espacio flexible */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Información del usuario */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {!isMobile && (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              <Typography
                variant="body2"
                sx={{
                  color: '#111827',
                  fontWeight: 500,
                  fontSize: '0.875rem',
                }}
              >
                {currentUser?.name || 'Usuario'}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: '#6b7280',
                  fontSize: '0.75rem',
                }}
              >
                {currentUser?.role || 'Usuario'}
              </Typography>
            </Box>
          )}

          {/* Avatar/Menu del usuario */}
          <IconButton onClick={handleProfileMenuOpen} sx={{ padding: 0 }}>
            <Avatar
              sx={{
                width: 36,
                height: 36,
                backgroundColor: '#111827',
                color: '#ffffff',
                fontSize: '0.875rem',
                fontWeight: 500,
              }}
            >
              {getInitials(currentUser?.name)}
            </Avatar>
          </IconButton>

          {/* Menú desplegable del usuario */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleProfileMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              '& .MuiPaper-root': {
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                minWidth: 180,
              },
            }}
          >
            <MenuItem
              onClick={handleProfileMenuClose}
              sx={{
                paddingY: 1.5,
                paddingX: 2,
                '&:hover': {
                  backgroundColor: '#f9fafb',
                },
              }}
            >
              <Person sx={{ marginRight: 2, color: '#6b7280' }} />
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#111827' }}>
                  {currentUser?.name || 'Usuario'}
                </Typography>
                <Typography variant="caption" sx={{ color: '#6b7280' }}>
                  {currentUser?.email || 'email@ejemplo.com'}
                </Typography>
              </Box>
            </MenuItem>

            <MenuItem
              onClick={handleLogout}
              sx={{
                paddingY: 1.5,
                paddingX: 2,
                color: '#dc2626',
                '&:hover': {
                  backgroundColor: '#fef2f2',
                },
              }}
            >
              <ExitToApp sx={{ marginRight: 2 }} />
              Cerrar Sesión
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header; 